import { classNames } from "primereact/utils";
import styles from "./CalendarView.module.scss";
import {
  useCalendarViewDays,
  ICalendarDayItem,
} from "./hooks/useCalendarViewDays";

const DAY_LABELS = ["Пон", "Вт", "Ср", "Чт", "Пет", "Съб", "Нед"];

interface ICalendarViewProps {
  selectedDate?: Date | null;
  onDateSelect: (date: Date) => void;
  currentMonth: Date;
  onMonthChange: (month: Date) => void;
  className?: string;
  studioHours?: {
    [key: string]: {
      slots: Array<{ startTime: string; endTime: string }>;
      isWorkingDay: boolean;
    };
  } | null;
  hasRealData?: boolean;
  hasAvailableSlots?: (date: Date) => boolean;
  numberOfDays?: number;
}

export const CalendarView = ({
  selectedDate,
  onDateSelect,
  className,
  studioHours,
  hasRealData = false,
  hasAvailableSlots,
  numberOfDays = 14,
}: ICalendarViewProps) => {
  const calendarItems = useCalendarViewDays({
    numberOfDays,
    selectedDate,
    studioHours,
    hasRealData,
    hasAvailableSlots,
  });

  const handleDateClick = (dayData: ICalendarDayItem) => {
    if (!dayData.isDisabled) {
      onDateSelect(dayData.date);
    }
  };

  return (
    <div className={classNames(styles.calendarContainer, className)}>
      <div className={styles.dayLabels}>
        {DAY_LABELS.map((label) => (
          <div key={label} className={styles.dayLabel}>
            {label}
          </div>
        ))}
      </div>

      <div className={styles.calendarGrid}>
        {calendarItems.map((item) => {
          if (item.kind === "banner") {
            return (
              <div key={item.key} className={styles.monthBanner}>
                {item.label}
              </div>
            );
          }
          if (item.kind === "empty") {
            return <div key={item.key} className={styles.emptyDay} />;
          }
          return (
            <div
              key={item.key}
              className={classNames(styles.calendarDay, {
                [styles.disabled]: item.isDisabled,
                [styles.selected]: item.isSelected,
                [styles.noSlots]: !item.hasSlots,
              })}
              onClick={() => handleDateClick(item)}
              title={!item.hasSlots ? "Няма свободни часове за тази дата." : ""}
            >
              {item.day}
            </div>
          );
        })}
      </div>
    </div>
  );
};
